<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { obsInThePastHelper } from '@/helpers/obsInThePastHelper'

@Component({
    props: {
        completedObservations: Number,
        selectedObservations: Array,
        remainingInYear: Number   
    }
})

export default class CompletedObservationStats extends Vue {

    arrow = require('../../assets/images/up-arrow.jpg')

    displayObsInThePast(days){
        return obsInThePastHelper().obsInThePast(this.selectedObservations, days)
    }

    observationsIncrease(displayObsInThePast){
        return this.completedObservations - displayObsInThePast <= 0
            ? `${(displayObsInThePast * 100).toFixed(1)}%`
            : `${((displayObsInThePast * 100 / (this.completedObservations-displayObsInThePast)).toFixed(1))}%`
    }

}
</script>

<template>
    <div>
        <div class="thirty-day stats">
            <p>{{displayObsInThePast('month')}}</p>
            <p>observations completed this month</p>
        </div>
        <div class="observations-increase stats">
            <p>{{observationsIncrease(displayObsInThePast(14))}}
                <span class="arrow">
                    <img :src="arrow"/>
                </span>
            </p>
            <p>in observations in the past two weeks</p>
        </div>
        <div class="remaining-observations stats">
            <p>{{remainingInYear}}</p>
            <p>observations left in the window</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    div {
        margin-left: 15px;
        .stats {
            border: 1px solid #979797;
            width: 234px;
            height: 112px;
            text-align: center;
            &:not(:last-child){
                margin-bottom: 30px;
            }
            .arrow {
                position: absolute;
                margin: 5px;
            }
            p:first-child{
                font-size: 40px;
                margin: 17px 0 0;
            }
        }
    }
</style>